"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const localization_service_1 = require("./localization.service");
const localization_controller_1 = require("./localization.controller");
const localization_repository_1 = require("./localization.repository");
const typeorm_1 = require("@nestjs/typeorm");
const localization_regulatory_fields_country_map_entity_1 = require("../../../../service-lib/src/lib/entities/localization-regulatory-fields-country-map.entity");
const localization_company_regulatory_field_entity_1 = require("../../../../service-lib/src/lib/entities/localization-company-regulatory-field.entity");
const localization_country_entity_1 = require("../../../../service-lib/src/lib/entities/localization-country.entity");
const user_1 = require("../../../../service-lib/src/lib/entities/user");
const organisation_entity_1 = require("../../../../service-lib/src/lib/entities/organisation.entity");
let LocalizationModule = class LocalizationModule {
};
exports.LocalizationModule = LocalizationModule;
exports.LocalizationModule = LocalizationModule = tslib_1.__decorate([
    (0, common_1.Module)({
        controllers: [localization_controller_1.LocalizationController],
        providers: [localization_service_1.LocalizationService, localization_repository_1.LocalizationRepository],
        imports: [
            typeorm_1.TypeOrmModule.forFeature([
                localization_regulatory_fields_country_map_entity_1.LocalizationRegulatoryFieldsCountryMap,
                localization_company_regulatory_field_entity_1.LocalizationCompanyRegulatoryFields,
                localization_country_entity_1.LocalizationCountry,
                user_1.User,
                organisation_entity_1.Organisation
            ]),
            LocalizationModule
        ],
        exports: [localization_service_1.LocalizationService, localization_repository_1.LocalizationRepository],
    })
], LocalizationModule);
